import React from 'react';
import { Redirect } from 'react-router-dom'
import { Popover, Button }from 'react-bootstrap';
import { connect } from "react-redux";
import { toast } from 'react-toastify';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faCheckSquare, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import './notify.css';
import { appInsights } from "../../AppInsights";
import { SeverityLevel } from '@microsoft/applicationinsights-common';
import { Dropdown } from "react-bootstrap";
import {
    saveNotification,
    updateNotification,
    deleteNotification,
    deleteMultipleNotifications,
    downloadnotificationData
} from '../../actions';


var timeoutHandle;

const initialState = {
    data: [],
    show: false,
    target: null,
    highlight: false,
}

class Notify extends React.Component {
    constructor(props) {
        super(props)
        this.getDayDiff = this.getDayDiff.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.handleNotificationClick = this.handleNotificationClick.bind(this)
        this.hide = this.hide.bind(this)
        this.markAsRead = this.markAsRead.bind(this)
        this.state = {
            ...initialState,
        }
        
        this.props.downloadnotificationData()
    }
    
    getDayDiff = datetime => {
        let a = moment();
        let b = datetime;
        let diff = a.diff(b, 'year');
        if (diff === 0) {
            diff = a.diff(b, 'month');
            if (diff === 0) {
                diff = a.diff(b, 'days');
                if (diff === 0) {
                    diff = a.diff(b, 'hour');
                    if (diff === 0) {
                        diff = a.diff(b, 'minute');
                        if (diff === 0) {
                            diff = a.diff(b, 'second');
                            return `${diff} second(s) before`;
                        } else {
                            return `${diff} minute(s) before`;
                        }
                    } else {
                        return `${diff} hour(s) before`;
                    }
                } else {
                    return `${diff} days(s) before`;
                }
            } else {
                return `${diff} month(s) before`;
            }
        } else {
            return `${diff} year(s) before`;
        }
    }

    componentDidMount(){
        if(this.props.downloadnotification.length>0){
            let index = -1;
            for (let i = 0; i < this.props.downloadnotification.length; i++) {
                if (moment().diff(this.props.downloadnotification[i].datetime) <= 0) {
                    index = i;
                    break;
                }
            }
    
            let newData = (index === -1)?this.props.downloadnotification:this.props.downloadnotification.slice(0, index)
            this.setState({
                data: newData,
            })
        } 
    }
    componentDidUpdate(){
        if(this.props.downloadnotification.length>0){
            let index = -1;
            for (let i = 0; i < this.props.downloadnotification.length; i++) {
                if (moment().diff(this.props.downloadnotification[i].datetime) <= 0) {
                    index = i;
                    break;
                }
            }


            let newData = (index === -1)?this.props.downloadnotification:this.props.downloadnotification.slice(0, index)
            if(index !== -1){
                let now = moment()
                let date = this.props.downloadnotification[index]['datetime']
                if(timeoutHandle){
                    clearTimeout(timeoutHandle)
                }
                timeoutHandle = setTimeout(() => {this.forceUpdate()}, -1*now.diff(date)) 
            }
            if(newData.length > this.state.data.length){
                this.setState({
                    data: newData,
                    highlight: true
                })
                this.props.checkNewNotif(true)
            }
            else{
                let ids = this.state.data.map((obj) => obj.id)
                let isSuperset = true;
                for (let i = 0; i < newData.length; i++) {
                    if (ids.indexOf(newData[i].id) < 0) {
                        isSuperset = false;
                        break;
                    }
                }
                if(!isSuperset){
                    this.setState({
                        data: newData,
                        highlight: true
                    })
                    this.props.checkNewNotif(true)
                }
                else if(this.state.data.length !== newData.length){
                    this.setState({
                        data: newData
                    })
                }
            }
        }
    }

    markAsRead = (e) => {
        this.setState({ show: false })
        if(this.state.data.length>0){
            this.props.deleteMultipleNotifications().then(response => {
                if (response.status === 204) {
                    appInsights.trackTrace({message:'All Expried Notifications are marked as done!', severityLevel: SeverityLevel.Verbose})
                    toast.success("All Expried Notifications are marked as done!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                    this.props.downloadnotificationData()
                    this.setState({
                        ...initialState
                    })
                    this.props.checkNewNotif(false)
                }
                else {
                    appInsights.trackTrace({message: 'Expried Notifications couldn\'t marked as done!', properties: {page: "notifyOverlay"}, severityLevel: SeverityLevel.Error});
                    toast.error("Notifications couldn't be marked as done!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            })
        }
    }

    handleNotificationClick = () =>{
        this.setState({ redirect: true, show: false })
        window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth'})
        setTimeout(() => this.setState({ redirect: false}), 2000)
    }

    handleClick = (event) => {
            this.setState({
                show: !(this.state.show),
                target: event.target,
                highlight: false,
            })
            this.props.checkNewNotif(false)        
        }

    hide = () => {
        this.setState({
            show: false,
        })
    }


    render(){
        return (
            <>
                <div className={this.state.data.length ? 'notification notify show-count' : 'notification'}
                    data-count={this.state.data.length} onClick={event => this.handleClick(event)}>
                    <div className={this.state.highlight && this.state.data.length?"blink-me":""} color={'#364db2'}><FontAwesomeIcon icon={faBell} className='fa-1x demo-icon'></FontAwesomeIcon> Notifications</div>
                </div>
                <Dropdown ref={this.ref}>
                    {/* <Dropdown.Toggle
                        show={this.state.show}
                        target={this.state.target}
                        placement="bottom"
                        container={this.ref}
                        containerPadding={20}
                        rootClose={true}
                        onHide={this.hide}
                    >
                    </Dropdown.Toggle> */}
                         <Dropdown.Item id="popover-contained">
                            <Popover.Content  className="notification-padding" >
                                {this.state.data.length > 0 && <div>
                                    <Button variant="link" onClick={(e) => this.markAsRead()} className="d-flex">
                                    <FontAwesomeIcon className="icons" icon={faCheckSquare} szie="lg"></FontAwesomeIcon>
                                    <span className="mark-all-done">Mark all as done </span>
                                    </Button>
                                </div>
                                }
                                <ul className="notification-info-panel" onClick={this.handleNotificationClick}>
                                    {
                                        this.state.data.length > 0 ?
                                        
                                        this.state.data.map((message, index) =>
                                            <li
                                                className='notification-message'
                                                key={index}>
                                                <div className="timestamp">
                                                    <span>{this.getDayDiff(message['datetime'])}</span>
                                                </div>
                                                <div className="message"><li><abbr className="notification-data" title={message['description']}>{message['description'].length>=30? message['description'].slice(0,10)+'...' : message['description']}</abbr></li></div>
                                           </li>
                                        ) :
                                        <div className="center-icon">
                                            <FontAwesomeIcon className="fa-2x"  color={'#364db2'} icon={faExclamationTriangle}></FontAwesomeIcon>
                                            <h5 className="nodata">No Notifications found!</h5>
                                        </div>
                                    }
                                </ul>
                            </Popover.Content>
                        </Dropdown.Item>
                </Dropdown>
            {this.state.redirect?<Redirect to="/manage/notifications"/>:null}
            </>
        )
    }
}

const mapStateToProps = state => {

    return {
        downloadnotification: state.notification_data.downloadnotificationData,
    }
}

export default connect(
    mapStateToProps,
    {
        saveNotification,
        updateNotification,
        deleteNotification,
        deleteMultipleNotifications,
        downloadnotificationData
    }
)(Notify);